import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const quickLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/about' },
    { name: 'Ürünlerimiz', path: '/products' },
    { name: 'Doğallık ve Kalite', path: '/quality' },
    { name: 'Lezzet Köşesi', path: '/recipes' },
    { name: 'İletişim', path: '/contact' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-collaborator/artifacts/cyb27p3j_Pekala-Sut-Logo.png" 
              alt="Pekâlâ Süt ve Süt Ürünleri" 
              className="h-20 w-auto mb-4 bg-white p-2 rounded-lg"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Doğallığın ve lezzetin âlâsı. Süt ürünleri ve taze içeceklerde tazeliğin kaynağından sofranıza.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-300">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center hover:from-purple-700 hover:to-pink-700 transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://twitter.com/pekala_sut" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-sky-500 rounded-full flex items-center justify-center hover:bg-sky-600 transition-colors duration-300">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Hızlı Erişim</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Ürünlerimiz</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/products?category=süt"
                  className="text-gray-300 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  Süt Ürünleri
                </Link>
              </li>
              <li>
                <Link
                  to="/products?category=içecek"
                  className="text-gray-300 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  Taze İçecekler
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm leading-relaxed">
                  <p>{companyInfo.address.replace(' - ', ', ')}</p>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-green-400 flex-shrink-0" />
                <a
                  href={`tel:+905432026363`}
                  className="text-gray-300 hover:text-green-400 transition-colors duration-300 text-sm"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-green-400 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-300 hover:text-green-400 transition-colors duration-300 text-sm break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col items-center md:items-start space-y-2">
              <p className="text-gray-400 text-sm text-center md:text-left">
                © {new Date().getFullYear()} {companyInfo.name}. Tüm hakları saklıdır.
              </p>
              <div className="flex items-center space-x-4 text-xs">
                <Link to="/kvkk" className="text-gray-400 hover:text-green-400 transition-colors">
                  KVKK Aydınlatma Politikası
                </Link>
                <span className="text-gray-600">•</span>
                <Link to="/privacy" className="text-gray-400 hover:text-green-400 transition-colors">
                  Gizlilik Politikası
                </Link>
              </div>
            </div>
            <p className="text-gray-500 text-xs">
              {companyInfo.branch} • {companyInfo.country}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
